import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './RecommendedPostings.module.css';
import { useRecommendedPostings } from './useRecommendedPostings';
import { formatDeadline } from './postingRecommendationModel';

const INITIAL_COUNT = 4;

function PostingCard({ item }) {
  const deadline = formatDeadline(item.deadline);
  const roleLine = [item.roleName, item.roleType].filter(Boolean).join(' · ');
  return (
    <Link
      to={`/castings/${item.postId}`}
      state={{ backLabel: '대시보드로 돌아가기' }}
      className={styles.card}
    >
      <div className={styles.cardTop}>
        <div className={styles.chips}>
          <span className={styles.aiBadge}>AI 추천</span>
          {item.projectType && <span className={styles.typeChip}>{item.projectType}</span>}
        </div>
        {deadline.dday && (
          <span className={deadline.urgent ? styles.ddayUrgent : styles.dday}>{deadline.dday}</span>
        )}
      </div>
      <strong className={styles.title}>{item.title}</strong>
      {roleLine && <span className={styles.role}>{roleLine}</span>}
      {item.conditions.length > 0 && (
        <span className={styles.conditions}>{item.conditions.join(' · ')}</span>
      )}
      {item.reason && <p className={styles.reason}>{item.reason}</p>}
      <span className={styles.deadline}>{deadline.label}</span>
    </Link>
  );
}

function SkeletonCard() {
  return (
    <div className={styles.skeleton} aria-hidden="true">
      <div className={styles.skeletonLine} style={{ width: '30%' }} />
      <div className={styles.skeletonLine} style={{ width: '70%', height: 16 }} />
      <div className={styles.skeletonLine} style={{ width: '50%' }} />
    </div>
  );
}

/**
 * 배우 대시보드의 "나에게 맞는 공고" 섹션.
 * 배우 역할일 때만, 서버가 추천을 줄 수 있을 때만 보인다.
 */
function RecommendedPostings() {
  const { status, items } = useRecommendedPostings({ limit: 20 });
  const [expanded, setExpanded] = useState(false);

  if (status === 'hidden') return null;

  const visible = expanded ? items : items.slice(0, INITIAL_COUNT);
  const rest = items.length - INITIAL_COUNT;

  return (
    <section className={styles.section} aria-labelledby="recommended-postings-title" aria-busy={status === 'loading'}>
      <div className={styles.header}>
        <h2 id="recommended-postings-title" className={styles.heading}>나에게 맞는 공고</h2>
        <span className={styles.subheading}>내 프로필 조건에 맞는 모집 중인 배역</span>
      </div>

      {status === 'loading' && (
        <div className={styles.grid}>
          {[0, 1].map((i) => <SkeletonCard key={i} />)}
        </div>
      )}

      {status === 'empty' && (
        <div className={styles.empty}>
          <span className={styles.emptyText}>지금은 조건에 맞는 공고가 없어요.</span>
          <span className={styles.emptyHint}>프로필의 나이·키·특기를 채워 두면 더 잘 찾아드려요.</span>
        </div>
      )}

      {status === 'ready' && (
        <>
          <div className={styles.grid}>
            {visible.map((item) => <PostingCard key={item.key} item={item} />)}
          </div>
          {rest > 0 && (
            <button type="button" className={styles.moreButton} onClick={() => setExpanded((v) => !v)}>
              {expanded ? '접기' : `${rest}개 더 보기`}
            </button>
          )}
        </>
      )}
    </section>
  );
}

export default RecommendedPostings;
